import { useCallback } from 'react';

import { usePriceContext } from 'contexts';
import type { ProductTag } from 'models/product';

export function useProductTagsScreenReaderTextGetter() {
	const { usePriceExcVat } = usePriceContext();
	return useCallback(
		(tags: ProductTag[]) =>
			tags
				.map((tag) =>
					usePriceExcVat && tag.textExcVat ? tag.textExcVat : tag.text,
				)
				.join(', '),
		[usePriceExcVat],
	);
}

export function useProductTagsScreenReaderText(tags: ProductTag[]) {
	return useProductTagsScreenReaderTextGetter()(tags);
}
